export const headers = [
    { field: "id", headerName: "ID", width: 70, hidden: true },
    { field: "tem_descripcion", headerName: "Descripcion", width: 230 },
    {
      field: "tem_fechainicio",
      headerName: "Desde",
      width: 150,
      valueGetter: (params) => {
        const date = new Date(params.row.tem_fechainicio);
        return date.toLocaleDateString('es-ES'); // Formato YYYY-MM-DD
      },
    },
    {
      field: "tem_fechafin",
      headerName: "Hasta",
      width: 150,
      valueGetter: (params) => {
        const date = new Date(params.row.tem_fechafin);
        return date.toLocaleDateString('es-ES'); // Formato YYYY-MM-DD
      },
    },
    {
      field: "tem_activo",
      headerName: "Estado",
      width: 130,
      valueGetter: (params) => params.row.tem_activo ? "Vigente" : "Vencida",
    },
  ];
  